import { FeedbackController } from './feedback.controller';
import template from './feedback.html';

export default {
  name: 'feedbackComponent',
  restrict: 'E',
  bindings: {},
  controller: FeedbackController,
  controllerAs: 'vm',
  template,
};



// WEBPACK FOOTER //
// ./src/app/common/ui/feedback/feedback.component.js